import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDatepicker, MatSelect } from '@angular/material';
import * as moment from 'moment';

@Component({
	selector: 'azc-inline-field',
	templateUrl: './inline-field.component.html',
	styleUrls: ['./inline-field.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class InlineFieldComponent<T> implements OnInit {
	@Output() private onUpdate: EventEmitter<T> = new EventEmitter<T>();
	@Output() private onFocus: EventEmitter<T> = new EventEmitter<T>();
	@ViewChild('datePicker,control') private viewControl: MatDatepicker<T> | MatSelect | ElementRef;
	@Input() public value: T;
	@Input() public display?: string;
	@Input() public options?: any[];
	@Input() public type?: 'text' | 'textarea' | 'date' | 'location' | 'select' = 'text';
	public formControl: FormControl;
	public isEditMode: boolean;
	public isStandardInput: boolean;

	constructor(private _fb: FormBuilder) { }

	ngOnInit() {
		this.formControl = this._fb.control(this.value);
	}

	public toggleMode() {
		this.isEditMode = !this.isEditMode;
		if (this.isEditMode) {
			this.type = this.options ? 'select' : this.type;
			this.isStandardInput = !['select', 'date', 'location', 'textarea'].includes(this.type);

			let value: any = this.value;
			if (value && this.type === 'date' && typeof (value) === 'string') {
				value = moment(value as string);
			}
			this.formControl.setValue(value);
			setTimeout(() => this.focusElement(), 100);
		}
	}

	private focusElement() {
		if (!this.viewControl) return;

		if (this.viewControl instanceof MatSelect) {
			this.viewControl.open();
		} else if (this.viewControl instanceof MatDatepicker) {
			this.viewControl.open();
		} else if (this.viewControl.nativeElement) {
			this.viewControl.nativeElement.focus();
		}
	}

	public onChange($event, value) {
		const updatedValue = value || this.formControl.value;
		if (this.value !== updatedValue) {
			this.onUpdate.emit(updatedValue);
		}
		this.isEditMode = false;
	}

	public handleInputClick($event, value) {
		const updatedValue = value || this.formControl.value;
		this.onFocus.emit(updatedValue);
	}
}
